import React from 'react'
import Link from '../../Link'
import { FormattedMessage } from 'react-intl'


//компонент меню для роли персоны, содержащий ссылки с левой стороны
const HeaderMenuPerson = ({data}) => {
    return ( 
        <div className='Header__menu'>
            {/* <Link to='/profile' className='Header__menu-link'>
                <FormattedMessage id='header.about.me' />
            </Link>
            <Link to='/lots' className='Header__menu-link'>
                <FormattedMessage id='header.auctions' />
            </Link>
            <Link to='/personvisits' className='Header__menu-link'>
                <FormattedMessage id='header.visits' />
            </Link> */}
            <Link to='/persondocuments' className='Header__menu-link'>
                <FormattedMessage id='header.ducuments' />
            </Link>
            {/*<Link to='/reporting' className='Header__menu-link'>
                <FormattedMessage id='header.reporting' />
            </Link>*/}
        </div>
    )
}

export default HeaderMenuPerson;


// WEBPACK FOOTER //
// ./src/components/MenuComponents/menu/HeaderMenuPerson.jsx